import { Deal } from '@/types'
import { routes } from '@/router'
import { Card, Typography } from '@mui/material'
import { formatCNPJ } from '@/helpers'
import { generatePath, useNavigate } from 'react-router-dom'

const STORAGE_COMPANY_KEY = 'selected_company'

type CompanyCardProps = {
  deal: Deal
}

export function CompanyCard({ deal }: CompanyCardProps) {
  const navigate = useNavigate()

  const isOngoing = deal.status === 'ongoing'
  const isOpening = deal.status === 'incomplete' && deal.step === 'signed'
  const isIncomplete = deal.status === 'incomplete' && deal.step !== 'signed'
  const isClosed = deal.status === 'closed'

  const handleClick = () => {
    if (isIncomplete) {
      navigate(generatePath(routes.hiring.index, { deal_key: deal.key }))
      return
    }

    localStorage.setItem(STORAGE_COMPANY_KEY, deal.company.key)
    navigate(routes.dashboard)
  }

  const { company } = deal

  return (
    <Card onClick={handleClick} sx={{ cursor: 'pointer' }}>
      {isOngoing ? (
        <>
          <Typography fontWeight="bold">{company.corporate_name}</Typography>
          <Typography>
            {company.tax_id && formatCNPJ(company.tax_id)}
          </Typography>
        </>
      ) : isOpening ? (
        <>
          <Typography fontWeight="bold">{company.corporate_name}</Typography>
          <Typography color="warning">
            Processo de abertura em andamento
          </Typography>
        </>
      ) : isIncomplete ? (
        <Typography color="warning" fontWeight="bold">
          Processo de contratação em andamento
        </Typography>
      ) : isClosed ? (
        <>
          <Typography fontWeight="bold">{company.corporate_name}</Typography>
          <Typography color="textDisabled">Encerrada</Typography>
        </>
      ) : (
        <Typography fontWeight="bold">{company.corporate_name}</Typography>
      )}
    </Card>
  )
}
